'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionAssignmentTurnedIn = function ActionAssignmentTurnedIn(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' })
  );
};
ActionAssignmentTurnedIn = (0, _pure2.default)(ActionAssignmentTurnedIn);
ActionAssignmentTurnedIn.displayName = 'ActionAssignmentTurnedIn';

exports.default = ActionAssignmentTurnedIn;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/assignment-turned-in.js
 ** module id = 977
 ** module chunks = 0
 **/